<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Shipping Line Payment(Invoice wise)</b-navbar-brand>
        </b-navbar>

        <banner-component
          :allModuleIdBanner="ffExportDetail.allModuleId ? ffExportDetail.allModuleId :''"
          :jobSeriesBanner="ffExportDetail.ffExportFclSeries ? ffExportDetail.ffExportFclSeries :''"
          :bannerClientName="ffExportDetail.clientName ? ffExportDetail.clientName : ''"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <div>
              <!-- *******************************  Start  WareHouse  Warehouse Stuffing At ICD *****************************-->
              <div
                class="mt-2"
                v-if="containerTypeDetailFactoryList.length > 0"
              >
                <h5>
                  <b-badge>Container Details</b-badge>
                </h5>
                <div>
                  <b-button
                    v-if="
                      ContainerTypeSizefactory.ffExecutionContainerId != '' &&
                      showMoreSB == false
                    "
                    size="sm"
                    variant="outline-dark"
                    @click="showMoreSBDet"
                    >{{ showMoreSB == true ? "Show" : "Hide " }} Container
                    Details</b-button
                  >
                </div>

                <!-- /.box-header -->

                <b-card
                  class="mt-3"
                  v-if="
                    (getContainerList.length > 0 ||
                      ContainerTypeSizefactory.ffExecutionContainerId != '') &&
                    showMoreSB == false
                  "
                  style="background: whiteSmoke"
                >
                  <div
                    class="gutr"
                    v-if="
                      getContainerList.length > 0 ||
                      ContainerTypeSizefactory.ffExecutionContainerId != ''
                    "
                  >
                    <div v-if="showMoreSB == false">
                      <!-- <md-layout md-gutter>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="95">
                            <label>
                              <b>
                                <u>
                                  Container Details
                                  <span
                                    class="error"
                                    v-if="containerTypeDetailFactory.length==0"
                                  >{{errorAtleastContainer}}</span>
                                </u>
                              </b>
                            </label>
                          </md-layout>
                        </md-layout> -->

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="50">
                          <label
                            v-if="
                              ContainerTypeSizefactory.ffExecutionContainerId ==
                              ''
                            "
                            >Container Type/Size</label
                          >
                          <model-list-select
                            v-if="
                              ContainerTypeSizefactory.ffExecutionContainerId ==
                              ''
                            "
                            option-value="containerTypeId"
                            option-text="containerType"
                            :list="ContainerTypeList"
                            placeholder="Select  Type/Size"
                            v-model="ContainerTypeSizefactory.containerTypeId"
                          ></model-list-select>
                          <md-layout md-flex="100" v-else>
                            <label for="containerType"
                              >Container Type/Size</label
                            >
                            <b-form-input :formatter="capitalizeAll"
                              v-model="ContainerTypeSizefactory.containerType"
                              disabled
                            ></b-form-input>
                          </md-layout>
                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.containerTypeId"
                            >{{ errorContainer.containerTypeId }}</span
                          >
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="45">
                          <md-layout md-flex="100">
                            <label>Container No.(eg. AAAA1234567)</label>
                            <b-form-input :formatter="capitalizeAll"
                              name="containerNo"
                              v-model="ContainerTypeSizefactory.containerNo"
                              @keyup="containerNoRegexfun"
                            ></b-form-input>
                          </md-layout>
                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.containerNo"
                            >{{ errorContainer.containerNo }}</span
                          >
                          <span
                            class="error"
                            v-else-if="containerNoRegexError != ''"
                            >{{ containerNoRegexError }}</span
                          >
                          <span
                            class="error"
                            v-if="
                              containerNoRegexError == '' &&
                              ContainerTypeSizefactory.containerNo != '' &&
                              ContainerTypeSizefactory.containerNo !=
                                algoConNo &&
                              showAlgo == true
                            "
                            >Note:System Generated Container No. is :
                            {{ algoConNo }}</span
                          >
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="55"></md-layout>
                        <md-layout md-flex="10">
                          <md-layout md-flex="100">
                            <label>Net Wgt.</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="netWeight"
                              name="netWeight"
                              type="number"
                              min="0"
                              v-model="ContainerTypeSizefactory.netWeight"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="10">
                          <md-layout md-flex="100">
                            <label>Gross Wgt</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="grossWeight"
                              name="grossWeight"
                              type="number"
                              min="0"
                              v-model="ContainerTypeSizefactory.grossWeight"
                            ></b-form-input>
                          </md-layout>

                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.grossWeight"
                            >{{ errorContainer.grossWeight }}</span
                          >
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="15">
                          <label for="weightUnit">Unit</label>
                          <model-list-select
                            :list="unitList"
                            option-value="uV"
                            option-text="uT"
                            placeholder="Select Unit"
                            name="weightUnit"
                            id="weightUnit"
                            v-model="ContainerTypeSizefactory.weightUnit"
                          ></model-list-select>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="15">
                          <label>Handover Date</label>
                          <date-picker
                          :format="selectDateFormat"
                            lang="en"
                            :minute-step="1"
                            name="handoverDate"
                            id="handoverDate"
                            v-model="ContainerTypeSizefactory.handoverDate"
                          ></date-picker>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Custom Seal No.</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="customSealNo"
                              name="customSealNo"
                              v-model="ContainerTypeSizefactory.customSealNo"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Line Seal No.</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="LineSealNo"
                              name="LineSealNo"
                              v-model="ContainerTypeSizefactory.LineSealNo"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>Container Tare Wgt</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="tareWeight"
                              name="tareWeight"
                              type="number"
                              min="0"
                              v-model="ContainerTypeSizefactory.tareWeight"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>Measurement (in CBM)</label>
                            <b-form-input :formatter="capitalizeAll"
                              name="noOfpkgUnit"
                              id="noOfpkgUnit"
                              type="number"
                              min="0"
                              v-model="ContainerTypeSizefactory.measurement"
                            ></b-form-input>
                            <!-- <span
                    class="error"
                    v-if="!ContainerTypeSizefactory.measurement"
                              >{{errorContainer.measurement}}</span>-->
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <label>Package Details</label>
                          <model-list-select
                            :list="packageNameList"
                            id="clientId"
                            v-model="ContainerTypeSizefactory.packageId"
                            option-value="packageId"
                            option-text="packageName"
                            placeholder="Select  Package Name"
                          ></model-list-select>

                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.packageId"
                            >{{ errorContainer.packageId }}</span
                          >
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="50">
                          <md-layout md-flex="100">
                            <label
                              >No. of Packages ({{
                                ContainerTypeSizefactory.packageName
                              }})</label
                            >
                            <b-form-input :formatter="capitalizeAll"
                              name="noOfpkgUnit"
                              id="noOfpkgUnit"
                              type="number"
                              min="0"
                              :disabled="
                                ContainerTypeSizefactory.packageName == ''
                                  ? true
                                  : false
                              "
                              v-model="ContainerTypeSizefactory.noOfpkgUnit"
                            ></b-form-input>
                            <span
                              class="error"
                              v-if="!ContainerTypeSizefactory.noOfpkgUnit"
                              >{{ errorContainer.noOfpkgUnit }}</span
                            >
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="20">
                          <label>Cargo Stuffing Date</label>
                          <date-picker
                          :format="selectDateFormat"
                            lang="en"
                            name="cargoStuffingDate"
                            id="cargoStuffingDate"
                            v-model="ContainerTypeSizefactory.cargoStuffingDate"
                            :minute-step="1"
                          ></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <label>LEEO (Let Export Permit) Date</label>
                          <date-picker
                          :format="selectDateFormat"
                            lang="en"
                            name="leeoDate"
                            id="leeoDate"
                            v-model="ContainerTypeSizefactory.leeoDate"
                            :minute-step="1"
                          ></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="50">
                          <md-layout md-flex="100">
                            <label>LEEO (Let Export Permit) No.</label>
                            <b-form-input :formatter="capitalizeAll"
                              name="leeoNo"
                              id="leeoNo"
                              v-model="ContainerTypeSizefactory.leeoNo"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                    </div>
                  </div>
                </b-card>

                <div class="box-body mt-2">
                  <table id="ffContainer" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No.</th>

                        <th>Container No.</th>

                        <th>Container Type</th>
                        <th>Custom Seal No.</th>
                        <th>Line Seal No.</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in containerTypeDetailFactoryList"
                        :key="index"
                      >
                        <td>{{ index + 1 }}</td>
                        <td
                          @click="viewEdit(item.ffExecutionContainerId, index)"
                          class="showMoreData"
                        >
                          {{ item.containerNo }}
                        </td>
                        <td
                          @click="viewEdit(item.ffExecutionContainerId, index)"
                          class="showMoreData"
                        >
                          {{ item.containerType }}
                        </td>

                        <td>
                          {{
                            item.customSealNo != "" ? item.customSealNo : "--"
                          }}
                        </td>
                        <td>
                          {{ item.LineSealNo != "" ? item.LineSealNo : "--" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.box-body -->
              </div>
              <!-- <div
                class="mt-3"
                v-if="
                  (SBDetail.ffSlinePayId != '' && accounts == false) ||
                  (SBDetail.ffSlinePayId != '' && role == 'Admin')
                "
              >
                <b-button
                  id="show-btn"
                  size="sm"
                  variant="outline-primary"
                  @click="showModal"
                >
                  Add Supplementary Invoice</b-button
                >
              </div> -->
              <div
                class="mt-4"
                v-if="
                  (SBDetail.ffSlinePayId != '' && accounts == false) ||
                  (SBDetail.ffSlinePayId != '' && role == 'Admin')
                "
              >
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="SBDetail.revisedMail"
                  name="checkbox-1"
                  value="1"
                  unchecked-value="0"
                >
                </b-form-checkbox
                ><span class="error">Send Revised Payment Request</span>
              </div>

              <!-- <md-layout md-gutter class="gutr">
                <div v-if="viewBLDraftDoc.length > 0">
                  <md-layout
                    md-flex="20"
                    v-for="(item, index) in viewBLDraftDoc"
                    :key="index"
                  >
                    <a
                      v-if="ffExportDetail.ffExportFclSeries"
                      :href="
                        `${docURL}/ASSIGNMENT_UPLOADS/` +
                        ffExportDetail.ffExportFclSeries.replaceAll('/', '_') +
                        '/' +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                    <br />
                    <a
                      :href="
                        `${docURL}/FF_Sea_Export_Sline_Payments_Uploads/` +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </div>
                <md-layout md-flex="45"></md-layout>

                <div v-if="viewInvDoc.length > 0">
                  <md-layout
                    md-flex="20"
                    v-for="(item, index) in viewInvDoc"
                    :key="index"
                  >
                    <a
                      v-if="ffExportDetail.ffExportFclSeries"
                      :href="
                        `${docURL}/ASSIGNMENT_UPLOADS/` +
                        ffExportDetail.ffExportFclSeries.replaceAll('/', '_') +
                        '/' +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    ><br />
                    <a
                      :href="
                        `${docURL}/FF_Sea_Export_Sline_Payments_Uploads/` +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </div>
              </md-layout> -->

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>POD</label>
                    <b-form-input :formatter="capitalizeAll"
                      disabled
                      name="POD"
                      id="POD"
                      v-model="POD"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>B/L No.</label>
                    <b-form-input :formatter="capitalizeAll"
                      :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                      name="POD"
                      id="POD"
                      v-model="SBDetail.SlineBlNo"
                    ></b-form-input>
                    <span class="error" v-if="SBDetail.SlineBlNo == ''">{{errorSBExecution.SlineBlNo}}</span>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="35">
                  <md-layout md-flex="100" v-if="ffExportDetail.jobType !='MISC'">
                    <label>Shipping Line</label>
                    <b-form-input :formatter="capitalizeAll"
                      disabled
                      name="POD"
                      id="POD"
                      v-model="ffExportDetail.shippingLine"
                    ></b-form-input>
                    
                  </md-layout>

                  <md-layout md-flex="100" v-else>
                    <label>Shipping Line </label>
                   
                    <model-list-select
                    v-model="ffExportDetail.shippingLine"
                    :list="shipplingLineList"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                ></model-list-select>
                    
                  </md-layout>


                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Estimated SOB Date </label>
                  <date-picker
                    @input="getDueDate"
                    :disabled="
                      accounts == true && role != 'Admin' ? true : false
                    "
                    lang="en"
                    :format="selectDateFormat"
                    name="sobDate"
                    id="sobDate"
                    v-model="SBDetail.sobDate"
                    :minute-step="1"
                  ></date-picker>
                  <span class="error" v-if="SBDetail.sobDate == ''">{{errorSBExecution.sobDate}}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Payment Due Date</label>
                  <date-picker
                  :format="selectDateFormat"
                    disabled
                    lang="en"
                    name="sobDate"
                    id="sobDate"
                    v-model="SBDetail.dueDate"
                    :minute-step="1"
                  ></date-picker>
                  <!-- <span class="error" v-if="!SBDetail.payDate">{{errorSBExecution.payDate}}</span> -->
                </md-layout>
              </md-layout>

              <hr />

              <div class="my-2">
                <b-row>
                  <b-col
                  cols="6"
                  >
                    <md-input-container>
                      <label>B/L Draft By Shipping Line</label>
                      <md-file
                        :disabled="
                          accounts == true && role != 'Admin' ? true : false
                        "
                        name="invoiceUpload"
                        id="invoiceUpload"
                         v-model="SBDetail.blDraftUpload"
                        @selected="onFileChangeBlDraft('BL_DRAFT', 0)"
                        multiple
                      ></md-file> </md-input-container
                  ></b-col>
                </b-row>
              </div>

              <md-layout md-gutter class="gutr mb-2">
                <div v-if="viewBLDraftDoc.length > 0">
                  <md-layout
                    md-flex="20"
                    v-for="(item, index) in viewBLDraftDoc"
                    :key="index"
                  >
                    <a
                      v-if="ffExportDetail.ffExportFclSeries"
                      :href="
                        `${docURL}/ASSIGNMENT_UPLOADS/` +
                        ffExportDetail.ffExportFclSeries.replaceAll('/', '_') +
                        '/' +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                    <br />
                    <a
                      :href="
                        `${docURL}/FF_Sea_Export_Sline_Payments_Uploads/` +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </div>
                <md-layout md-flex="45"></md-layout>

                <!-- <div v-if="viewInvDoc.length > 0">
                  <md-layout
                    md-flex="20"
                    v-for="(item, index) in viewInvDoc"
                    :key="index"
                  >
                    <a
                      v-if="ffExportDetail.ffExportFclSeries"
                      :href="
                        `${docURL}/ASSIGNMENT_UPLOADS/` +
                        ffExportDetail.ffExportFclSeries.replaceAll('/', '_') +
                        '/' +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    ><br />
                    <a
                      :href="
                        `${docURL}/FF_Sea_Export_Sline_Payments_Uploads/` +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </div> -->
              </md-layout>

              <b-button
                id="show-btn"
                size="sm"
                variant="outline-primary"
                @click="addInvArry"
              >
                Add Invoice <i class="fa fa-plus" aria-hidden="true"></i
              ></b-button>
              <b-card
                class="mt-2"
                v-for="(itm, idx) in lineInvModalArray"
                :key="idx"
              >
              <div 
              class="d-flex align-items-center"
              v-if="idx != 0"
              >
                 <b-button
                 class="ml-auto"
                  id="show-btn"
                  size="sm"
                  variant="danger"
                  @click="removeInvArry(idx)"
                >
                  Remove Invoice <i class="fa fa-plus" aria-hidden="true"></i
                ></b-button>

              </div>

              <div
                class="mt-2"
                v-if="
                 SBDetail.revisedMail != 0
                "
              >
                <!-- <b-form-checkbox
                  id="checkbox-1"
                  v-model="selectedInvoice"
                  :name="`checkbox-${idx}`"
                  @input="addRevisedInvoice(idx)"
                  value="1"
                  unchecked-value="0"
                >
                </b-form-checkbox> -->
                <input :id="'checkbox-'+idx" type="checkbox" @click="addRevisedInvoice(idx,'checkbox-'+idx)">
                
                <span class="error">Revise Invoice</span>
              </div>

              <b-row align-v="start">
                <b-col cols="3">
                    <label>Invoice Category</label>
                  <model-list-select
                  multiple="true"
                  :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                      :list="invCategoryList"
                      v-model="itm.invCategory"
                      option-value="payVal"
                      option-text="payText"
                      placeholder="Select Category"
                    ></model-list-select>


                  </b-col>
              </b-row>
              
                <b-row align-v="start">

                  <!-- <b-col>
                    <md-input-container>
                      <label>B/L Draft By Shipping Line</label>
                      <md-file
                        :disabled="
                          accounts == true && role != 'Admin' ? true : false
                        "
                        name="invoiceUpload"
                        id="invoiceUpload"
                        v-model="itm.invBlDraftUpload"
                        @selected="onFileChangeBlDraft('BL_DRAFT', idx)"
                        multiple
                      ></md-file> </md-input-container
                  ></b-col> -->
                  
                  <b-col>
                    <md-input-container>
                      <label>Shipping Line Invoice</label>
                      <md-file
                        :disabled="
                          accounts == true && role != 'Admin' ? true : false
                        "
                        name="invoiceUpload"
                        id="invoiceUpload"
                        v-model="itm.invSlineUpload"
                        @selected="onFileChangeBlDraft('Sline_Invoice', idx)"
                      ></md-file> </md-input-container
                  ></b-col>

                  <b-col
                    ><label>Invoice No</label>
                    <b-form-input :formatter="capitalizeAll"
                      :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                      name="shippingBillNo"
                      id="shippingBillNo"
                      v-model="itm.invNo"
                    ></b-form-input
                  ></b-col>
                  <b-col>
                    <label>Invoice Type</label>
                  <!-- <model-list-select
                  multiple="true"
                  :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                      :list="invoiceTypeList"
                      v-model="itm.invType"
                      option-value="value"
                      option-text="text"
                      placeholder="Select Type"
                    ></model-list-select> -->

            <!-- onSelect(items,lastSelectItem,idx) -->

                    <multi-select :options="invoiceTypeList"
                       :selected-options="items"
                       placeholder="select Type"
                       
                       @select="(item) => {onSelect(idx, item)}"
                       >
                   </multi-select>
<!-- 
                   <multiselect v-model="items" :options="invoiceTypeList" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="select Type" label="name" track-by="name" :preselect-first="true">
                    
                  </multiselect> -->

                  <!-- <multiselect v-model="items" :options="invoiceTypeList" :searchable="false" :close-on-select="false" :show-labels="false" placeholder="Pick a value"></multiselect> -->
                  
                  </b-col>
                </b-row>
                <div v-if="viewInvDoc.length > 0">
                  <md-layout md-gutter class="gutr">
                    <!-- <md-layout md-flex="50"></md-layout> -->
                    <md-layout
                      md-flex="40"
                      v-for="(item, index) in viewInvDoc"
                      :key="index"
                    >
                      <a
                        v-if="ffExportDetail.ffExportFclSeries"
                        href="javascript:void(0)"
                        @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${ffExportDetail.ffExportFclSeries.replaceAll('/', '_')}/${item}`)"
                        >--View Document - {{ index + 1 }}</a
                      ><br />
                      <a
                        :href="
                          `${docURL}/FF_Sea_Export_Sline_Payments_Uploads/` +
                          item
                        "
                        target="_blank"
                        download
                        >--View Document - {{ index + 1 }}</a
                      >
                    </md-layout>
                  </md-layout>
                </div>

                <!-- ADD AMOUNT BUTTON  -->
                <b-row align-v="start">
                  <div 
                    class="d-flex align-items-center mt-3"
                    >
                      <b-button
                      class="ml-3"
                        id="show-btn"
                        size="sm"
                        variant="warning"
                        @click="addInvCurrency(idx)"
                      >
                        ADD AMOUNT <i class="fa fa-plus" aria-hidden="true"></i
                      ></b-button>

                    </div>
                </b-row>
                <!-- END ADD AMOUNT BUTTON  -->

                <!-- AMOUNT DETAILS START-->

                <b-card
                  class="mt-2"
                  v-for="(currItm, currIdx) in itm['invCurrencyList']"
                  :key="currIdx"
                  >
              
                <div>

                  <!-- REMOVE AMOUNT BUTTON  -->
                  <b-row v-if="currIdx != 0">
                    <b-col>
                      <div 
                      class="d-flex align-items-center mt-3"
                      >
                        <b-button
                        class="ml-auto"
                          id="show-btn"
                          size="sm"
                          variant="outline-danger"
                          @click="removeInvCurrency(idx,currIdx)"
                        >
                          REMOVE AMOUNT <i class="fa fa-plus" aria-hidden="true"></i
                        ></b-button>

                      </div>
                    </b-col>
                  </b-row>

                  <!-- AMOUNT FIELDS START  -->

                  <div>
                    <b-row>
                      <b-col
                      cols="3"
                        >
                          <label>Invoice Amount</label>
                          <b-form-input :formatter="capitalizeAll"
                            :disabled="
                              accounts == true && role != 'Admin' ? true : false
                            "
                            name="shippingBillNo"
                            id="shippingBillNo"
                           v-model="currItm.invAmount"
                          ></b-form-input
                        ></b-col>

                        <b-col
                        cols="3"
                          ><label>Currency</label>
                          
                        <model-list-select
                          :disabled="
                              accounts == true && role != 'Admin' ? true : false
                            "
                          :list="currList"
                          v-model="currItm.invCurrency"
                          option-value="payVal"
                          option-text="payText"
                          placeholder="Select Currency"
                        ></model-list-select>
                        
                        
                        </b-col>

                        <b-col
                         v-if="
                          (SBDetail.ffSlinePayId != '' && accounts == false) ||
                          (SBDetail.ffSlinePayId != '' && role == 'Admin')
                        "
                            ><label>Payment Mode</label>

                          <model-list-select
                              :list="payList"
                              v-model="currItm.invPayMode"
                              option-value="payVal"
                              option-text="payText"
                              placeholder="Select Mode"
                            ></model-list-select>
                          
                          </b-col>
                          <b-col
                           v-if="
                              (SBDetail.ffSlinePayId != '' && accounts == false) ||
                              (SBDetail.ffSlinePayId != '' && role == 'Admin')
                            "
                            ><label>Payment Ref</label>
                            <b-form-input :formatter="capitalizeAll"
                              name="shippingBillNo"
                              id="shippingBillNo"
                              v-model="currItm.invPayRef"
                            ></b-form-input
                          ></b-col>
                    </b-row>

                    <b-row
                     v-if="
                      (SBDetail.ffSlinePayId != '' && accounts == false) ||
                      (SBDetail.ffSlinePayId != '' && role == 'Admin')
                    "
                    >
                       <b-col
                        cols="4"
                        ><label>Payment Amount</label>
                        <b-form-input :formatter="capitalizeAll"
                          name="shippingBillNo"
                          id="shippingBillNo"
                          v-model="currItm.invPaidAmount"
                        ></b-form-input
                      ></b-col>
                      <b-col
                      class="mt-4"
                       cols="4"
                        ><label>Payment Date</label>
                      <date-picker
                      :format="selectDateFormat"
                        lang="en"
                        name="shippingBillNo"
                        id="shippingBillNo"
                        v-model="currItm.invPayDate"
                        :minute-step="1"
                      ></date-picker>
                      
                      </b-col>
                      <b-col
                       cols="4"
                        ><label>Payment Status</label>
                      
                      <model-list-select
                          :list="statusList"
                          v-model="currItm.invPayStatus"
                          option-value="payVal"
                          option-text="payText"
                          placeholder="Select Status"
                        ></model-list-select>
                      </b-col>
                      <b-col></b-col>
                     </b-row>

                    
                  </div>
                  

                  <!-- AMOUNT FIELDS END  -->

                </div>

                </b-card>
                


                 <!-- <b-row align-v="start">

                   <b-col>
                     <b-row>
                       <b-col
                          ><label>Invoice No</label>
                          <b-form-input :formatter="capitalizeAll"
                            :disabled="
                              accounts == true && role != 'Admin' ? true : false
                            "
                            name="shippingBillNo"
                            id="shippingBillNo"
                            v-model="itm.invNo"
                          ></b-form-input
                        ></b-col>
                        <b-col>
                          <label>Invoice Type</label>
                        <model-list-select
                        :disabled="
                              accounts == true && role != 'Admin' ? true : false
                            "
                            :list="payList"
                            v-model="itm.invType"
                            option-value="payVal"
                            option-text="payText"
                            placeholder="Select Type"
                          ></model-list-select>
                        
                        </b-col>
                     </b-row>

                    <div
                      v-if="
                        accounts == true ||
                        (SBDetail.paymentMode != '' && SBDetail.payRefNumber != '')
                      "
                    >

                    <b-row>
                        <b-col
                          ><label>Payment Mode</label>

                        <model-list-select
                            :list="payList"
                            v-model="itm.invPayMode"
                            option-value="payVal"
                            option-text="payText"
                            placeholder="Select Mode"
                          ></model-list-select>
                        
                        </b-col>
                        <b-col
                          ><label>Payment Ref</label>
                          <b-form-input :formatter="capitalizeAll"
                            name="shippingBillNo"
                            id="shippingBillNo"
                            v-model="itm.invPayRef"
                          ></b-form-input
                        ></b-col>
                     </b-row>


                     <b-row>
                       <b-col
                        ><label>Payment Amount</label>
                        <b-form-input :formatter="capitalizeAll"
                          name="shippingBillNo"
                          id="shippingBillNo"
                          v-model="itm.invPaidAmount"
                        ></b-form-input
                      ></b-col>
                      <b-col
                      class="mt-4"
                        ><label>Payment Date</label>
                      <date-picker
                        lang="en"
                        name="shippingBillNo"
                        id="shippingBillNo"
                        v-model="itm.invPayDate"
                        :minute-step="1"
                      ></date-picker>
                      
                      </b-col>
                     </b-row>


                     <b-row>

                       <b-col
                       cols="6"
                        ><label>Payment Status</label>
                      
                      <model-list-select
                          :list="payList"
                          v-model="itm.invPayStatus"
                          option-value="payVal"
                          option-text="payText"
                          placeholder="Select Status"
                        ></model-list-select>
                      </b-col>
                     </b-row>

                    </div>

                     

                   </b-col>

                    

                    

                   
                    <b-col>
                      <div 
                      class="d-flex align-items-center mt-3"
                      >
                        <b-button
                        class="ml-auto"
                          id="show-btn"
                          size="sm"
                          variant="warning"
                          @click="addInvCurrency(idx)"
                        >
                          ADD CURRENCY <i class="fa fa-plus" aria-hidden="true"></i
                        ></b-button>

                      </div>
                     <b-row
                     v-for="(currItm, currIdx) in itm['invCurrencyList']"
                      :key="currIdx"
                     >
                       <b-col
                       cols="5"
                       >
                        <label>Invoice Amount</label>
                        <b-form-input :formatter="capitalizeAll"
                          :disabled="
                            accounts == true && role != 'Admin' ? true : false
                          "
                          name="shippingBillNo"
                          id="shippingBillNo"
                          v-model="currItm.invAmount"
                        ></b-form-input
                      ></b-col>

                      <b-col
                      cols="5"
                        ><label>Currency</label>
                        
                      <model-list-select
                        :disabled="
                            accounts == true && role != 'Admin' ? true : false
                          "
                        :list="payList"
                        v-model="currItm.invCurrency"
                        option-value="payVal"
                        option-text="payText"
                        placeholder="Select Currency"
                      ></model-list-select>
                      
                      
                      </b-col>
                      <b-col
                      v-if="currIdx != 0"
                      cols="2"
                        >
                        <b-button
                          style="margin-top:40px;"
                            id="show-btn"
                            size="sm"
                            variant="outline-danger"
                            @click="removeInvCurrency(idx,currIdx)"
                          >
                            Remove
                          </b-button>
                      </b-col>
                     </b-row>

                     

                   </b-col>
                  

                 </b-row> -->


                 <!-- OLD INVOICE FORM  -->

                <!-- <b-row align-v="start">
                  <b-col
                    ><label>Invoice No</label>
                    <b-form-input :formatter="capitalizeAll"
                      :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                      name="shippingBillNo"
                      id="shippingBillNo"
                      v-model="itm.invNo"
                    ></b-form-input
                  ></b-col>
                  <b-col>
                    <label>Invoice Type</label>
                   <model-list-select
                   :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                      :list="payList"
                       v-model="itm.invType"
                      option-value="payVal"
                      option-text="payText"
                      placeholder="Select Type"
                    ></model-list-select>
                  
                  </b-col>
                  <b-col>
                    <label>Invoice Amount</label>
                    <b-form-input :formatter="capitalizeAll"
                      :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                      name="shippingBillNo"
                      id="shippingBillNo"
                      v-model="itm.invAmount"
                    ></b-form-input
                  ></b-col>

                  <b-col
                    ><label>Currency</label>
                    
                  <model-list-select
                    :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                    :list="payList"
                     v-model="itm.invCurrency"
                    option-value="payVal"
                    option-text="payText"
                    placeholder="Select Currency"
                  ></model-list-select>
                  
                  
                  </b-col>
                </b-row>
                <b-row
                  align-v="start"
                  v-if="
                    accounts == true ||
                    (SBDetail.paymentMode != '' && SBDetail.payRefNumber != '')
                  "
                >
                  <b-col
                    ><label>Payment Mode</label>

                  <model-list-select
                      :list="payList"
                       v-model="itm.invPayMode"
                      option-value="payVal"
                      option-text="payText"
                      placeholder="Select Mode"
                    ></model-list-select>
                  
                  </b-col>
                  <b-col
                    ><label>Payment Ref</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="shippingBillNo"
                      id="shippingBillNo"
                      v-model="itm.invPayRef"
                    ></b-form-input
                  ></b-col>
                  <b-col
                    ><label>Payment Amount</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="shippingBillNo"
                      id="shippingBillNo"
                      v-model="itm.invPaidAmount"
                    ></b-form-input
                  ></b-col>
                  <b-col
                    ><label>Payment Date</label>
                  <date-picker
                    lang="en"
                    name="shippingBillNo"
                    id="shippingBillNo"
                    v-model="itm.invPayDate"
                    :minute-step="1"
                  ></date-picker>
                  
                  </b-col>
                  <b-col
                    ><label>Payment Status</label>
                  
                  <model-list-select
                      :list="payList"
                       v-model="itm.invPayStatus"
                      option-value="payVal"
                      option-text="payText"
                      placeholder="Select Status"
                    ></model-list-select>
                  </b-col>
                </b-row> -->
              </b-card>



              <!-- <div
                v-if="
                  accounts == true ||
                  (SBDetail.paymentMode != '' && SBDetail.payRefNumber != '')
                "
              >
                <md-layout md-gutter class="mt-3">
                  <md-layout md-flex="95">
                    <h5>
                      <b-badge>Payment Details</b-badge>
                    </h5>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter>
                  <md-layout md-flex="40">
                    <label for="custmClearByPridel">Payment Mode</label>

                    <model-list-select
                      :list="payList"
                      v-model="SBDetail.paymentMode"
                      option-value="payVal"
                      option-text="payText"
                      placeholder="Select Mode"
                    ></model-list-select>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="10">
                    <md-layout md-flex="100">
                      <label>Amount</label>
                      <b-form-input :formatter="capitalizeAll"
                        name="shippingBillNo"
                        id="shippingBillNo"
                        v-model="SBDetail.totalAmount"
                      ></b-form-input>
                    </md-layout>
                 
                  </md-layout>

                  <md-layout
                    md-flex="5"
                    v-if="SBDetail.paymentMode != ''"
                  ></md-layout>
                  <md-layout md-flex="25" v-if="SBDetail.paymentMode != ''">
                    <md-layout md-flex="100">
                      <label
                        >{{
                          SBDetail.paymentMode == "1" ? "UTR" : "Cheque"
                        }}
                        Number</label
                      >
                      <b-form-input :formatter="capitalizeAll"
                        name="cargoGrossWeight"
                        id="cargoGrossWeight"
                        v-model="SBDetail.payRefNumber"
                      ></b-form-input>
                    </md-layout>
                   
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label>Payment Date</label>
                    <date-picker
                      lang="en"
                      name="shippingBillDate"
                      id="shippingBillDate"
                      v-model="SBDetail.payDate"
                      :minute-step="1"
                    ></date-picker>
                 
                  </md-layout>
                </md-layout>
              </div> -->
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="25">
                  <!-- <b-button
                    v-if="lineInvModalArray.length > 0"
                    class="mt-3"
                    :disabled="
                      SBDetail.paymentDone == '1' || disableSave == true
                        ? true
                        : false
                    "
                    variant="primary"
                    id="addButtonLoaderSB"
                    @click="addSBDetail"
                    >Save & Submit
                  </b-button> -->

                  <b-button
                    v-if="lineInvModalArray.length > 0"
                    class="mt-3"
                    variant="primary"
                    id="addButtonLoaderSB"
                    @click="addSBDetail"
                    >Save & Submit
                  </b-button>


                  <md-spinner
                    md-indeterminate
                    id="loaderSB"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>
            </div>
            <div class="mt-4" v-if="suplimentaryInvData.length > 0">
              <h5>Supplementary Invoice</h5>
              <table class="table table-sm table-bordered">
                <tbody>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Invoice Added Date</th>
                    <th scope="col">Invoice Amount</th>
                    <th scope="col">SOB Date</th>
                    <th scope="col">Due Date</th>
                    <th scope="col">Payment Status</th>
                    <th scope="col">Amount Paid</th>
                    <th scope="col">Payment Date</th>
                    <th scope="col">Action</th>
                  </tr>
                  <tr v-for="(item, index) in suplimentaryInvData" :key="index">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ item.loginTime }}</td>
                    <td>{{ item.invoiceAmount }}</td>
                    <td>{{ item.sobDate }}</td>
                    <td>{{ item.dueDate }}</td>
                    <td :bgcolor="item.paymentDone == '1' ? 'Green' : 'Red'">
                      {{ item.paymentDone == "1" ? "Completed" : "Pending" }}
                    </td>
                    <td>{{ item.totalAmount }}</td>
                    <td>{{ item.payDate }}</td>
                    <td>
                      <b-button
                        size="sm"
                        @click="getSingleSupPay(item.supffSlinePayId)"
                        variant="outline-primary"
                        >Edit / Make Payment</b-button
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div>
      <b-modal
        id="supModal"
        ref="my-modal"
        size="xl"
        hide-footer
        title=""
      >
        <suplimentry-inv
          :suplimentaryInvDataSingleArry="getSuplimentaryInvData"
          :key="componentKey"
        />
        <b-button class="mt-3" variant="outline-danger" block @click="hideModal"
          >Close</b-button
        >
        <!-- <b-button class="mt-2" variant="outline-warning" block @click="toggleModal">Toggle Me</b-button> -->
      </b-modal>
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="popMailAfter"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect,MultiSelect } from "vue-search-select";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import SuplimentryInv from "../freightForwarding/ffSLineSuplimentryPayment.vue";
import Multiselect from 'vue-multiselect'

import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalContainerValid,
} from "../../helper/collection";

export default {
  beforeMount() {
       this.getShippingList();
      this.getData();
    // if (
    //   (globalPermissionStatus("Sea Freight") ||
    //     globalPermissionStatus("Accounts")) &&
    //   this.$sessionsStorage.get("editExportFCLId") != undefined &&
    //   this.$sessionsStorage.get("editExportFCLId") != ""
    // ) {
    //   this.$store.dispatch(
    //     "setCurrentRoute",
    //     "/freightForward/ffSLinePaymentExport"
    //   );
    //   this.getData();
    // } else {
    //   this.$router.push({
    //     path: "/dashboard",
    //   });
    // }
  },
  watch: {
    ContainerTypeSizefactory: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("containerNo")) {
          this.ContainerTypeSizefactory.containerNo =
            newVal.containerNo.toUpperCase();

          if (this.ContainerTypeSizefactory.packageId != "") {
            let arrayNew = this.packageNameList.filter((x) => {
              return x.packageId == this.ContainerTypeSizefactory.packageId;
            });

            if (arrayNew.length > 0) {
              this.ContainerTypeSizefactory.packageName =
                arrayNew[0].packageName;
            }
          }
        }
      },
      deep: true,
    },
  },

  data() {
    return {
      selectDateFormat,
      accounts: globalPermissionStatus("Accounts"),
      invBlDraftUpload : "",
      componentKey: 0,
      revisedInvoiceDetails : [],
      selectedInvoice : [],
       shipplingLineList: [],
      items: [],
      lastSelectItem: {},
      payList: [
        {
          payVal: "1",
          payText: "RTGS",
        },
        {
          payVal: "2",
          payText: "Cheque",
        },
      ],
      statusList: [
        {
          payVal: "1",
          payText: "PARTIAL",
        },
        {
          payVal: "2",
          payText: "COMPLETED",
        },
      ],
      currList: [
        {
          payVal: "INR",
          payText: "INR",
        },
        {
          payVal: "USD",
          payText: "USD",
        },
      ],
      invCategoryList: [
        {
          payVal: "Supplementary",
          payText: "Supplementary",
        },
        {
          payVal: "Normal",
          payText: "Normal",
        },
      ],
      invoiceTypeList: [
        {
          value: "1",
          text: "OCEAN FREIGHT",
        },
        {
          value: "2",
          text: "DETENTION",
        },
        {
          value: "3",
          text: "SURRENDER",
        },
        {
          value: "4",
          text: "LDC",
        },
        {
          value: "5",
          text: "LOCAL CHARGES",
        },
         {
          value: "6",
          text: "BOOKING CANCELLATION INVOICE",
        },
      ],
      showAlgo: false,
      algoConNo: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      value12: "",
      CCdone: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      unitList: [
        {
          uT: "KGS",
          uV: "KGS",
        },
        {
          uT: "MT",
          uV: "MT",
        },
      ],

      CCList: [
        {
          ccInfoVal: "Yes",
          ccInfoText: "Yes",
        },
        {
          ccInfoVal: "No",
          ccInfoText: "No",
        },
      ],
      getContainerList: [],
      getLocationList: [],
      ffExportDetail: {
        POD: "",
        allModuleId: "",
        clientName: "",
        ffExportFclSeries: "",
        portType: "",
        stuffingType: "",
        containerInfo: "",
        mergeffExportId: "",
        mergeSeries: "",
        shippingLine: "",
        FinalPlace: "",
        POR: "",
        jobType:""
      },
      POD: "",
      SBDetail: {
        revisedMail: "0",
        dueDate: "",
        SlineBlNo: "",
        invoiceAmount: "",
        sobDate: "",
        allModuleId: "",
        paymentDone: "",
        userId: "",
        stuffingType: "",
        blDraftUpload: "",
        slineInvoice: "",
        suplimentaryInvCount: "",
        ffSlinePayId: "",
        ffExportFclId: "",
        ffBookingId: "",
        ffExecutionId: "",

        paymentMode: "",
        totalAmount: "",
        payRefNumber: "",
        payDate: "",
        salesExeuctionNo: "",
        sline: "",
        clientName: "",
        isMiscJob : 1
      },

      errorSBExecution: {
        // shippingBillDate: "",
        // shippingBillNo: "",
        sobDate: "",
        SlineBlNo: "",

        cargoGrossWeight: "",
      },
      arraySBExecutionError: [
        "Enter Shippping Bill Date",
        "Enter Shipping Bill No",
        "Enter Cargo Weight",
      ],
      errorAtleastSb: "",
      errorAtleastContainer: "",

      WarehouseStuffing: {
        vgmSubmissionDate: "",
        gateInDate: "",
        siSubmissionDate: "",
        ffExecutionId: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),

        stuffingType: "",
        portType: "",

        nameOfCFS: "",
        cartingDate: "",
        crnNumber: "",

        custmClearByPridel: "",
        ccAsignmentNo: "",
        containerInfo: "",
      },
      permissionStatus: true,
      sbDetailArray: [],
      suplimentaryInvData: [],
      getSuplimentaryInvData: [],
      showMoreSB: false,

      errorExecution: {
        cartingDate: "",
        crnNumber: "",
      },
      nameOfCFSError: "",
      arrayExecutionError: ["Select Carting Date", "Enter CRN Number"],

      ContainerTypeSizefactory: {
        netWeight: "",
        weightUnit: "",
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        cargoStuffingDate: "",
        leeoDate: "",
        leeoNo: "",
        handoverDate: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },

      removeContainerVmodel: {
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },
      role: this.$sessionsStorage.get("designation"),
      packageNameList: [],
      nextPageType: "",

      errorContainer: {
        containerTypeId: "",
        containerNo: "",
        grossWeight: "",
        //    measurement: "",
        packageId: "",
        noOfpkgUnit: "",
      },
      arrayContainerError: [
        "Select Container Type",
        "Enter Container No.",
        "Enter Container Gross Weight1",
        // "Enter measurement",
        "Select Package",
        "Enter No of Packages",
      ],
      ContainerFromTPT: [],
      ContainerNoTPT: [],
      ContainerNoTypeTPT: [],
      editIndex: "",
      deleteId: "",
      showDivCountNote: false,
      lineInvModalArray: [],
      BookingShippingLine: {
        assignmentNumber: "",
        bookingNumber: "",
        uploadBooking: "",
        validityBookingDate: "",
        bookingDate: "",
        vesselName: "",
        SICutOff: "",
        gateOpenDate: "",
        gateOpenTime: "",
        gateCloseDate: "",
        gateCloseTime: "",
        portCutDate: "",
        portCutTime: "",
        ENSCutDate: "",
        ENSCutTime: "",
        bookingShipment: "",
        stuffingType: "",
        vesselEta: "",
        vesselEtd: "",
        vgmCutOffDate: "",
        documentCutOffDate: "",
        voyageNo: "",
      },
      validateTrans: true,
      validateSB: true,
      containerTypeDetailFactory: [],
      containerNoRegexError: "",
    };
  },

  mounted() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    MultiSelect,
    // Loading,
    CustomLoader,
    SuplimentryInv,
    BannerComponent,
    Multiselect
  },
  computed: {
    disableSave() {
      return this.accounts == false &&
        this.role != "Admin" &&
        (!this.SBDetail.SlineBlNo ||
          !this.SBDetail.invoiceAmount ||
          !this.SBDetail.sobDate)
        ? true
        : false;
    },
    viewBLDraftDoc() {
      return this.SBDetail.blDraftUpload != ""
        ? this.SBDetail.blDraftUpload.split(",")
        : [];
    },
    viewInvDoc() {
      return this.SBDetail.slineInvoice != ""
        ? this.SBDetail.slineInvoice.split(",")
        : [];
    },

    viewSlineInvDoc() {
      return this.SBDetail.slineInvoice != ""
        ? this.SBDetail.slineInvoice.split(",")
        : [];
    },
    sbDetailArrayList() {
      return this.sbDetailArray;
    },
    containerTypeDetailFactoryList() {
      return this.containerTypeDetailFactory;
    },
    ContainerTypeList() {
      return this.getContainerList;
    },
    masterList() {
      return this.getLocationList;
    },
  },
  methods: {
    onSelectionChange(event){

      console.log("Events= > ",event);
    },
    onSelect(index,items,lastSelectItem) {
      
        this.items = items
        this.lastSelectItem = lastSelectItem;
        this.lineInvModalArray[index].invTypeArr = items

        
        this.lineInvModalArray[index].invType = JSON.stringify(this.items)
        console.log(this.lineInvModalArray[index].invType);

      },
      // deselect option
      reset () {
        this.items = [] // reset
      },
      // select option from parent component
      selectFromParentComponent () {
        this.items = _.unionWith(this.items, [this.options[0]], _.isEqual)
        console.log("Item =>",this.items);
      },
    addInvArry() {
      console.log("Add invoice");
      let obj = {
        invId: "",
        ffExportFclId: "",
        allModuleId: "",
        invSlineUpload: "",
        invBlDraftUpload: "",
        invNo: "",
        invAmount: "",
        invCurrency: "",
        invCurrencyList : [{
           invAmount: "",
           invCurrency: "",
           invPayMode: "",
           invPaidAmount: "",
           invPayRef: "",
           invPayDate: "",
           invPayStatus: "",
        }],
        invType: "",
        invCategory : "",
        invTypeArr: [],
        invPayMode: "",
        invPaidAmount: "",
        invPayRef: "",
        invPayDate: "",
        invPayStatus: "",
      };
      this.lineInvModalArray.push(obj);

      console.log(this.lineInvModalArray.length);
    },

     getShippingList() {
      let send_request = {
        requestId: "SLINE",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_SlineBillingSeaExport/shipplingLineList.php`,
        data: JSON.stringify(send_request),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("shipping line => ", data);
            this.shipplingLineList = data.data;
          }
        })
        .catch((error) => {});
    },

    addInvCurrency(index){

      let obj = {
        invAmount: "",
        invCurrency: "",
        invPayMode: "",
        invPaidAmount: "",
        invPayRef: "",
        invPayDate: "",
        invPayStatus: "",
      }

      this.lineInvModalArray[index].invCurrencyList.push(obj)

    },

    addRevisedInvoice(index,id){

      var checkBox = document.getElementById(id).checked;
      console.log("Id => "+id+" : "+checkBox);
      if(checkBox){
        this.revisedInvoiceDetails.push(this.lineInvModalArray[index]);
      } 
      else{
        this.revisedInvoiceDetails.splice(index,1)
      }
      
      console.log("Revised mail => ",this.revisedInvoiceDetails); 
    },

    removeInvArry(index){
      this.lineInvModalArray.splice(index,1)
    },
    removeInvCurrency(invIndex,currIndex){
      this.lineInvModalArray[invIndex].invCurrencyList.splice(currIndex,1)
    },
    getSingleSupPay(itemId) {
      this.componentKey += 1;
      this.getSuplimentaryInvData = [];
      let arraysing = this.suplimentaryInvData.filter((y) => {
        return y.supffSlinePayId == itemId;
      });

      if (arraysing.length > 0) {
        this.getSuplimentaryInvData = arraysing;
        this.getSuplimentaryInvData[0]["suplimentaryInvCount"] =
          this.SBDetail.suplimentaryInvCount;
        this.$refs["my-modal"].show();
      }
    },
    showModal() {
      this.componentKey += 1;
      this.getSuplimentaryInvData = [];
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.getSuplimentaryInvData = [];
      this.$refs["my-modal"].hide();
      this.getData();
    },
    getDueDate() {
      var date = new Date(this.SBDetail.sobDate);
      console.log(date);
      if (this.ffExportDetail.shippingId == "15") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 9);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else if (this.ffExportDetail.shippingId == "8") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 9);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else if (this.ffExportDetail.shippingId == "13") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 9);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else if (this.ffExportDetail.shippingId == "27") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 13);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 6);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      }
    },
    onFileChangeBlDraft(ID, index) {
      this.isLoading = true;
      let files = event.target.files || event.dataTransfer.files;
      let exportfclId = this.$sessionsStorage.get("editExportFCLId");
       let allModuleId = this.$sessionsStorage.get("editSalesExId");
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);

        if (ID == "Sline_Invoice") {
          formData.append(
            "staticFileName",
            "Sea_Export_SlinePay_SlineInv_" + allModuleId
          );
        } else if (ID == "BL_DRAFT") {
          formData.append(
            "staticFileName",
            "Sea_Export_SlinePay_BLDraft_" + allModuleId
          );
        }

        formData.append(
          "upload_dir_folderName",
          // "FF_Sea_Export_Sline_Payments_Uploads"
          this.ffExportDetail.ffExportFclSeries.replaceAll("/", "_")
        );
      }

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: ID + exportfclId,
        },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          if (ID == "BL_DRAFT") {
            this.SBDetail.blDraftUpload = result.data;
          } else {
            this.lineInvModalArray[index].invSlineUpload = result.data;
            this.SBDetail.slineInvoice = result.data;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          throw err;
        });
    },

    getConAlgoList() {
      //let self = this;

      if (this.ContainerTypeSizefactory.containerNo != "") {
        this.validContainerNo = GlobalContainerValid(
          this.ContainerTypeSizefactory.containerNo
        );
      }
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      window.history.go(-1);
      // if (this.ffExportDetail.containerInfo == "lcl") {
      //   this.$router.push({
      //     path: "/freightForward/ffExportFcl"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/freightForward/ffBooking"
      //   });
      // }
    },

    validateSBDetail() {
      let validate_new = true;
      Object.keys(this.errorSBExecution).map((x, index) => {
        if (this.SBDetail[x] == "") {
          this.errorSBExecution[x] = this.arraySBExecutionError[index];
          validate_new = false;
        }
      });

      console.log(this.errorSBExecution)

      if (validate_new == false) {
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
    },
    showMoreSBDet() {
      if (this.showMoreSB == false) {
        this.ContainerTypeSizefactory.ffExecutionContainerId == "";
        this.showMoreSB = true;
      } else {
        this.showMoreSB = false;
      }
    },
    viewEdit(id, index) {
      let array = this.containerTypeDetailFactory.filter((x) => {
        return x.ffExecutionContainerId == id;
      });

      Object.keys(this.ContainerTypeSizefactory).map((x) => {
        this.ContainerTypeSizefactory[x] = array[0][x];
      });
      this.showMoreSB = false;
    },

    addSBDetail() {

      // console.log("Before => ",this.SBDetail);

      // console.log("Invoice => ",this.lineInvModalArray);

      this.SBDetail["ffExportFclSeries"] =
        this.ffExportDetail.ffExportFclSeries.replaceAll("/", "_");

      if (
        !this.SBDetail.slineInvoice ||
        (!this.SBDetail.blDraftUpload && this.SBDetail.ffSlinePayId == "")
      ) {

        console.log(this.SBDetail.slineInvoice+" : "+this.SBDetail.blDraftUpload+" : "+this.SBDetail.ffSlinePayId);
        this.alert.content = "Please Upload Shipping Line Invoice and BL Draft";
        this.$refs["addPop"].open();
        return false;
      }
      this.SBDetail["uploadArray"] = [];
      if (this.SBDetail.slineInvoice) {
        let obj = {
          allModuleId: this.ffExportDetail.allModuleId,
          docName:
            "SLINE_INVOICE-" +
            this.$sessionsStorage.get("editSalesExId"),
          docLink: this.SBDetail.slineInvoice,
        };
        this.SBDetail.uploadArray.push(obj);
      }
      if (this.SBDetail.blDraftUpload) {
        let obj1 = {
          allModuleId: this.ffExportDetail.allModuleId,
          docName:
            "BL_LINEINVOICEREQ-" +
            this.$sessionsStorage.get("editSalesExId"),
          docLink: this.SBDetail.blDraftUpload,
        };
        this.SBDetail.uploadArray.push(obj1);
      }

      this.SBDetail["stuffingType"] = this.WarehouseStuffing.stuffingType;
      this.SBDetail["ffExportFclId"] =
        this.$sessionsStorage.get("editExportFCLId");
      this.SBDetail["ffBookingId"] =
        this.$sessionsStorage.get("editFFBookingId");
      this.SBDetail["ffExecutionId"] = "0";
       this.SBDetail.allModuleId = this.ffExportDetail.allModuleId;
      this.SBDetail.clientName = this.ffExportDetail.clientName;
      this.SBDetail.sline = this.ffExportDetail.shippingLine;
      this.SBDetail.POD = this.ffExportDetail.POD;
      this.SBDetail.salesExeuctionNo = this.ffExportDetail.ffExportFclSeries;
      this.SBDetail.isMiscJob = 1;

      this.SBDetail.invoiceDetails = this.lineInvModalArray

      if(this.revisedInvoiceDetails.length > 0){
        this.SBDetail.revisedInvoiceDetails = this.revisedInvoiceDetails
      }
      console.log("After => ",this.SBDetail);
      //return false
      this.validateSBDetail();
      console.log("Validation => ",this.validateSB);
      // this.validateSB = false;
      if (this.validateSB != false) {
        $("#addButtonLoaderSB").css("display", "none");
        $("#loaderSB").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_SlineBillingSeaExport/addseaExportSlinePayment_multi.php`,
          data: JSON.stringify(this.SBDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              $("#loaderSB").css("display", "none");
              $("#addButtonLoaderSB").css("display", "block");
              window.history.go(-1);
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
            }
          })
          .catch((error) => {});
      }
    },

    containerNoRegexfun() {
      this.showAlgo = true;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;
      // let lastDigitReturn = this.validContainerNo.slice(
      //   this.validContainerNo.length - 7
      // );
      // let lastDigitCon = this.ContainerTypeSizefactory.containerNo.slice(
      //   this.ContainerTypeSizefactory.containerNo.length - 7
      // );
      let containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      let arrayLen = [];
      if (this.ContainerTypeSizefactory.ffExecutionContainerId == "") {
        arrayLen = this.containerTypeDetailFactoryList.filter((x) => {
          return x.containerNo == this.ContainerTypeSizefactory.containerNo;
        });
      }

      if (
        arrayLen.length > 0 &&
        this.ContainerTypeSizefactory.ffExecutionContainerId == ""
      ) {
        this.containerNoRegexError = "Already Exist";
      } else if (
        containerformat.test(this.ContainerTypeSizefactory.containerNo)
      ) {
        this.containerNoRegexError = "";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
      }
    },

    getData() {
      this.doLoading();
      if (this.sbDetailArrayList.length == 1) {
        this.sbDetailArray = [];
      }
      if (this.containerTypeDetailFactory.length == 1) {
        this.containerTypeDetailFactory = [];
      }
      if (this.getContainerList.length == 1) {
        this.getContainerList = [];
      }
      let new_data = {
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId:
          this.$sessionsStorage.get("editFFBookingId") != "" &&
          this.$sessionsStorage.get("editFFBookingId") != undefined
            ? this.$sessionsStorage.get("editFFBookingId")
            : "",
          allModuleId: this.$sessionsStorage.get("editSalesExId"),
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewFFBookingDetails_NewV3.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {

             
            if (data.ContainerFromTPT.length > 0) {
              if (!this.$sessionsStorage.get("editFFExecutionId")) {
                this.$sessionsStorage.set(
                  "editFFExecutionId",
                  data.autoExecutionId
                );
              }
              this.ContainerFromTPT = data.ContainerFromTPT;

              if (data.ContainerFromTPT[0].ContainerNumber != null) {
                this.ContainerNoTPT =
                  data.ContainerFromTPT[0].ContainerNumber.split(",");
              }
              if (data.ContainerFromTPT[0].ContainerType.length > 0) {
                this.ContainerNoTypeTPT =
                  data.ContainerFromTPT[0].ContainerType.split(",");
              }
              this.conDetailsTPT =
                data.ContainerFromTPT[0].ContainerType +
                "\n" +
                data.ContainerFromTPT[0].ContainerNumber;
            }

            

            this.getLocationList = data.portLocationArray;

            if (data.containerCountWise && data.containerCountWise.length > 0) {

              this.containerCountWise = data.containerCountWise;
              let array_new = this.containerCountWise.map((x) => {
                if (x.totalCount == 0) {
                  this.showDivCountNote = false;
                } else {
                  this.showDivCountNote = true;
                  return false;
                }
              });
            }

            

            if (data.mainSalesData.length > 0) {
        
              this.ffExportDetail.allModuleId = data.mainSalesData[0].allModuleId;
              this.ffExportDetail.ffExportFclSeries = data.mainSalesData[0].mainSalesSeries;
              this.ffExportDetail.clientName = data.mainSalesData[0].clientName;
              this.ffExportDetail.jobType = data.mainSalesData[0].jobType;
              this.ffExportDetail.shippingLine = data.mainSalesData[0].shippingId;
              
            }
            

           
            if (data.packageNameList && data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }

            if (data.containerMaster && data.containerMaster.length > 0) {
              this.getContainerList = data.containerMaster;
            }

            if (data.ffBookingDetail && data.ffBookingDetail.length > 0) {
              Object.keys(data.ffBookingDetail[0]).map((x) => {
                this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
              });
            }

            

            if (data.editFFEX && data.editFFEX.length > 0) {
              this.WarehouseStuffing.portType = data.editFFEX[0].portType;
              this.SBDetail.allModuleId = data.editFFEX[0].allModuleId;
              this.POD = data.editFFEX[0].POD;

              this.WarehouseStuffing.stuffingType =
                data.editFFEX[0].stuffingType;

              this.WarehouseStuffing.containerInfo =
                data.editFFEX[0].containerInfo;
              Object.keys(data.editFFEX[0]).map((x) => {
                this.ffExportDetail[x] = data.editFFEX[0][x] || "";
              });
            }

            if (data.ffBookingTranshipment.length > 0) {
              this.tentativeDetailArray = data.ffBookingTranshipment;
            }


            //  (this.$sessionsStorage.get("editFFExecutionId") != "" &&
            //   this.$sessionsStorage.get("editFFExecutionId") != undefined) ||

            if (
              this.$sessionsStorage.get("editSalesExId") != ""
            ) {
              this.viewExecutionDetail();
            } else {
              this.doLoadingClose();
            }
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    viewExecutionDetail() {
      this.doLoading();
      // this.doLoadingClose();
      let new_data = {
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        newData: this.ffExportDetail,
         allModuleId: this.$sessionsStorage.get("editSalesExId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewExecutionDetailsMulti.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      console.log("Execution");

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          this.doLoadingClose();

          if ( status == 200 && data) {

            console.log("count => ",data.ffSLinePayDetail.length)
            if (data.ffSLinePayDetail.length > 0) {
              Object.keys(this.SBDetail).map((x) => {
                this.SBDetail[x] = data.ffSLinePayDetail[0][x] || "";
              });

              Object.keys(this.lineInvModalArray).map((x) => {
                this.lineInvModalArray[x] = data.ffSLinePayDetail[0][x] || "";
              });

              data.ffSLinePayDetail.forEach(element => {

                console.log("Element => ",element);

                let amount = element['invoiceAmount'].split(',')
                let currency = element['invoiceCurrency'].split(',')

                element['invNo'] = element.ffSlineInvNo
                element['invType'] = element.ffSlineInvType
                element['invCategory'] = element.ffSlineInvCategory

                 console.log(element['invNo']+" : "+element['invType']);

                let invCurrencyList = [];

                for(var i=0;i< amount.length;i++){
                  
                  invCurrencyList.push({
                    'invAmount' : amount[i],
                    'invCurrency' : currency[i]
                  })
                }

                element['invCurrencyList'] = invCurrencyList


                //this.lineInvModalArray.push(element)
              });

              data.ffSLinePayInvoices.forEach(element => {

                element['invNo'] = element.ffSlineInvNo
                element['invType'] =element.ffSlineInvType
                element['invCategory'] = element.ffSlineInvCategory
                this.items = JSON.parse(element.ffSlineInvType);


                var invoiceAmount = data.ffSLinePayAmount.filter(amoIndex => {

                  return amoIndex.ffSlineInvId == element.ffSlineInvId
                });

                let invCurrencyList = [];

                for(var i=0;i< invoiceAmount.length;i++){
                  
                  invCurrencyList.push({
                    "ffSlineInvAmoId" : invoiceAmount[i].ffSlineInvAmoId,
                    "invNo" : invoiceAmount[i].ffSlineInvNo || "",
                    "invId" : invoiceAmount[i].ffSlineInvId || "",
                    "invPayId" : invoiceAmount[i].ffSlinePayId || "",
                    'invAmount' : invoiceAmount[i].ffSlineInvAmount || "",
                    'invCurrency' : invoiceAmount[i].ffSlineInvCurrency || "",
                    'invPayMode' : invoiceAmount[i].ffSlineInvPayMode || "",
                    'invPayRef' : invoiceAmount[i].ffSlineInvPayRef || "",
                    'invPaidAmount' : invoiceAmount[i].ffSlineInvPaidAmount || "",
                    'invPayDate' : invoiceAmount[i].ffSlineInvPayDate || "",
                    'invPayStatus' : invoiceAmount[i].ffSlineInvPayStatus || "",
                    
                  })
                }


                element['invCurrencyList'] = invCurrencyList;

                this.lineInvModalArray.push(element)
              });


            }

            console.log("SBDetails new => ",this.lineInvModalArray);
            if (data.ffExecutionDetail.length > 0) {
              Object.keys(this.WarehouseStuffing).map((x) => {
                this.WarehouseStuffing[x] = data.ffExecutionDetail[0][x] || "";
              });
            }

            if (data.ffExecutionDetailContainer.length > 0) {
              if (this.ContainerFromTPT.length > 0) {
                let dummyContainer = [];
                for (
                  let i = 0;
                  i < data.ffExecutionDetailContainer.length;
                  i++
                ) {
                  let obj = {
                    ffExecutionContainerId:
                      data.ffExecutionDetailContainer[i].ffExecutionContainerId,
                    containerTypeId:
                      data.ffExecutionDetailContainer[i].containerTypeId,
                    containerType:
                      data.ffExecutionDetailContainer[i].containerType,
                    LineSealNo: data.ffExecutionDetailContainer[i].LineSealNo,
                    PickupLocation:
                      data.ffExecutionDetailContainer[i].PickupLocation,
                    StuffingLocation:
                      data.ffExecutionDetailContainer[i].StuffingLocation,
                    cargoStuffingDate:
                      data.ffExecutionDetailContainer[i].cargoStuffingDate,
                    cargoWeight: data.ffExecutionDetailContainer[i].cargoWeight,
                    containerInfo:
                      data.ffExecutionDetailContainer[i].containerInfo,
                    containerWithSplit:
                      data.ffExecutionDetailContainer[i].containerWithSplit,
                    customSealNo:
                      data.ffExecutionDetailContainer[i].customSealNo,
                    ffExecutionId:
                      data.ffExecutionDetailContainer[i].ffExecutionId,
                    ffExportFclId:
                      data.ffExecutionDetailContainer[i].ffExportFclId,
                    grossWeight: data.ffExecutionDetailContainer[i].grossWeight,
                    handoverDate:
                      data.ffExecutionDetailContainer[i].handoverDate,
                    leeoDate: data.ffExecutionDetailContainer[i].leeoDate,
                    leeoNo: data.ffExecutionDetailContainer[i].leeoNo,
                    measurement: data.ffExecutionDetailContainer[i].measurement,
                    netWeight: data.ffExecutionDetailContainer[i].netWeight,
                    noOfpkgUnit: data.ffExecutionDetailContainer[i].noOfpkgUnit,
                    packageId: data.ffExecutionDetailContainer[i].packageId,
                    pickupDate: data.ffExecutionDetailContainer[i].pickupDate,
                    portType: data.ffExecutionDetailContainer[i].portType,
                    stuffingDate:
                      data.ffExecutionDetailContainer[i].stuffingDate,
                    tareWeight: data.ffExecutionDetailContainer[i].tareWeight,
                    weightUnit: data.ffExecutionDetailContainer[i].weightUnit,
                    containerNo:
                      data.ffExecutionDetailContainer[i].containerNo == ""
                        ? this.ContainerNoTPT[i]
                        : data.ffExecutionDetailContainer[i].containerNo,
                  };
                  dummyContainer.push(obj);
                }
                this.containerTypeDetailFactory = dummyContainer;
              } else {
                this.containerTypeDetailFactory =
                  data.ffExecutionDetailContainer;
              }

              Object.keys(this.ContainerTypeSizefactory).map((x) => {
                this.ContainerTypeSizefactory[x] =
                  data.ffExecutionDetailContainer[0][x] || "";
              });

              Object.keys(this.removeContainerVmodel).map((x) => {
                this.ContainerTypeSizefactory[x] = "";
              });
            }

            if (data.ffSBDetail.length > 0) {
              this.sbDetailArray = data.ffSBDetail;
            }
            if (data.suplimentaryInvData.length > 0) {
              this.suplimentaryInvData = data.suplimentaryInvData;
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ffContainer").DataTable();
    //   });
    // }
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// miscInvoiceSlinePayment.vue?20b2401e